import React from "react"
import { useTranslation } from "react-i18next"

import classNames from "classnames"

import { Floor } from "shared/types/Floor"
import { WithClassName } from "shared/types/WithClassName"
import { Icon } from "shared/ui/icon/Icon"
import { IconName } from "shared/ui/icon/__generated__/IconName"

import "./styles/_floor-title.scss"

export interface FloorTitleProps extends WithClassName {
  floor: Pick<Floor, "label" | "hasClarificationRequest">
  showClarificationRequestIndicator?: boolean
}

export const FloorTitle = React.memo(
  ({
    className,
    floor: { label, hasClarificationRequest },
    showClarificationRequestIndicator
  }: FloorTitleProps) => {
    const { t } = useTranslation()

    return (
      <div className={classNames("floor-title", className)}>
        <Icon name={IconName.FLOOR} className="floor-title__icon" />
        <span className="floor-title__text">{label || ""}</span>
        {showClarificationRequestIndicator && hasClarificationRequest ? (
          <div className="floor-title__cr-indicator">
            <span className="visually-hidden">
              {t("ClarificationRequest.Indicator")}
            </span>
            <Icon name={IconName.CLARIFICATION_REQUEST} />
          </div>
        ) : null}
      </div>
    )
  }
)
